import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Form, Input, Tooltip } from "antd";

export const __FormInput: FC<IFormItem> = (props) => {
    // console.log(props)
    const title = <span style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); props?.copyText?.(props.fieldName) }}>复制</span>
    return (
        <Form.Item
            // label={<Tooltip onDoubleClick={(e)=>{e.stopPropagation();props?.copyText?.(props.fieldName)}}>{props.fieldLabel}</Tooltip>}
            label={<Tooltip title={title}>{props.fieldLabel}</Tooltip>}
            name={props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol}
        >
            <Input
                disabled={props.disable}
                allowClear={props.allowClear}
                suffix={props.suffix}
                prefix={props.prefix}
                placeholder={props.placeholder}
            />
        </Form.Item>
    )
}